document.addEventListener('DOMContentLoaded', function () {
	try {
		const config = typeof pp_helpdesk === 'object' && pp_helpdesk ? pp_helpdesk : null
		if (!config) return
		const widgetType = config.pp_helpdesk_type
		const styles = config.pp_helpdesk || {}
		const zendeskKey = config.pp_helpdesk_key
		const isZendeskOffset = config.pp_is_sticky_footer
		let loading = false

		window.zESettings = {
			webWidget: {
				contentOnPageLoad: false,
				offset: { horizontal: '0px', vertical: isZendeskOffset == 1 ? '80px' : '0', mobile: { vertical: isZendeskOffset == 1 ? '80px' : '0', horizontal: '0px' } },
				launcher: { label: { '*': styles.tr_helpdesk_text_label } },
				color: {
					launcher: styles.helpdesk_icon_background_color || '#0ED13D',
					launcherText: styles.helpdesk_text_color || '#fff',
					button: styles.helpdesk_widget_button_color,
					header: styles.helpdesk_widget_header_color,
					theme: styles.helpdesk_widget_theme_color,
				},
			},
		}

		function loadZendesk() {
			if (loading || widgetType !== 'zendesk' || !zendeskKey) return
			loading = true
			const script = document.createElement('script')
			script.id = 'ze-snippet'
			script.async = true
			script.crossOrigin = 'anonymous'
			script.src = `https://static.zdassets.com/ekr/snippet.js?key=${encodeURIComponent(zendeskKey)}`
			script.onerror = function () { console.error('[snag-vendor-zendesk.js] Zendesk failed to load') }
			document.head.appendChild(script)
		}

		;['scroll', 'touchstart', 'pointerdown'].forEach(function (eventName) {
			window.addEventListener(eventName, loadZendesk, { once: true, passive: true })
		})
		setTimeout(loadZendesk, 5000)

		const liveChat = document.querySelector('#liveChat')
		if (liveChat && widgetType === 'zendesk') liveChat.addEventListener('click', function (event) {
			event.preventDefault()
			loadZendesk()
			if (typeof window.zE === 'function') window.zE('webWidget', 'open')
		})
	} catch (error) {
		console.error('[snag-vendor-zendesk.js] initialization failed', error)
	}
})
